import { FC } from 'react';

import { StyledNoData } from './NoData.styles';
import { NoDataProps } from './NoData.types';

const NoData: FC<NoDataProps> = ({ message }) => {
  return <StyledNoData data-testid={'no-data'}>{message}</StyledNoData>;
};

export default NoData;
